export default function UpgradePrompt({ resource, used, limit, tier, onUpgrade }) {
  const resourceNames = {
    posts: "posts",
    images: "image generations",
    videos: "video generations",
    proposals: "proposals",
    social_accounts: "social accounts",
    scheduled_posts: "scheduled posts",
  };

  const name = resourceNames[resource] || resource;
  const isZeroLimit = limit === 0;

  return (
    <div className="p-4 rounded-xl bg-gradient-to-r from-amber-950/50 via-orange-950/40 to-red-950/40 border border-amber-500/30 text-center space-y-2">
      <div className="text-amber-400 font-bold text-sm">
        {isZeroLimit
          ? `${name.charAt(0).toUpperCase() + name.slice(1)} not available on ${tier} plan`
          : `${name.charAt(0).toUpperCase() + name.slice(1)} limit reached (${used}/${limit})`}
      </div>
      <p className="text-gray-400 text-xs">
        {isZeroLimit
          ? `Upgrade your plan to unlock ${name}.`
          : `You've used all your monthly ${name}. Upgrade for more.`}
      </p>
      {onUpgrade && (
        <button
          onClick={onUpgrade}
          className="mt-2 px-4 py-1.5 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs font-bold hover:from-purple-500 hover:to-pink-500 transition-all"
        >
          Upgrade Plan
        </button>
      )}
    </div>
  );
}
